import { TravelType } from '../../insurance/stores/plan/types'

export const customerTransactionInfoInitialValues = {
  prefixId: '',
  name: '',
  isThai: true,
  surname: '',
  gender: '',
  identityNumber: '',
  passport: '',
  phoneNumber: '',
  birthDate: '',
  email: '',
  beneficiaryId: '',
  travelDate: '',
  returnDate: '',
  address: '',
  provinceId: '',
  districtId: '',
  subdistrictId: '',
  postalCode: '',
  nationalityId: ''
}

export const travelDetailInitialValues = {
  insurerId: '',
  insurancePlanId: '',
  country: '',
  countryId: '',
  totalPerson: '',
  travelDate: '',
  returnDate: '',
  travelType: TravelType.Trip,
  startProvinceId: '',
  destinationProvinceId: '',
  departureFlightId: '',
  departureFlightCode: '',
  arrivalFlightId: '',
  arrivalFlightCode: '',
  page: '1',
  pageSize: '10'
}

export const domesticTransactionRequiredKey = [
  'insurerId',
  'insurancePlanId',
  'countryId',
  'totalPerson',
  'travelDate',
  'returnDate',
  'travelType',
  'startProvinceId',
  'destinationProvinceId'
]

export const internationalTransactionRequiredKey = [
  'insurerId',
  'insurancePlanId',
  'countryId',
  'totalPerson',
  'travelDate',
  'returnDate',
  'travelType'
]
